﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = "api/sopnl/v1/user/domain";

const method = "GET";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export interface GetUserCustomerDomainResponse {
    Properties: GetUserCustomerDomainResponseProperties;
}

export interface GetUserCustomerDomainResponseProperties {
    EmployerName?: string;
    ProviderNamePensionFund?: string;
}

interface GetUserCustomerDomainProps extends api.ApiHookBaseProps<
    unknown,
    GetUserCustomerDomainResponse,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useGetUserCustomerDomain(
    props: GetUserCustomerDomainProps
): [boolean, () => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        GetUserCustomerDomainResponse,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        GetUserCustomerDomainResponse,
        unknown
    >(apiParams);
    return [loading, () => invoker(apiParams.uri, undefined)];
}
